import { FeatureFlagsState } from './types'

export const featureFlagsSelector = (state: any) =>
  state.featureFlags as FeatureFlagsState
